package fr.labodoc.webapp.pages.aboutUs

import fr.labodoc.healthProfessional.webApp.Page
import fr.labodoc.healthProfessional.webApp.components.hr
import fr.labodoc.healthProfessional.webApp.components.labodocButton
import fr.labodoc.healthProfessional.webApp.components.navigoLink
import fr.labodoc.require
import io.kvision.core.Container
import io.kvision.html.*
import io.kvision.panel.SimplePanel
import org.koin.core.component.KoinComponent

class WhoAreWePage() : SimplePanel(), KoinComponent {

  init {
    id = "page-about-us"
    require("./css/pages/aboutUs/about-us.css")
    div(className = "labodoc-background-beige d-flex flex-row align-center pb-xs-6") {
      id = "page-about-header"

      div(className = "labodoc-background-beige col-xl-6 col-lg-6 col-12") {
        id = "page-about-presentation"

        div(className = "page-width d-flex flex-column pt-5 pt-lg-10 pt-xl-10 align-xs-center") {
          id = "page-about-presentation-content"

          h1 (className = "mb-8 text-xs-center mb-xs-4"){
            content = "Qui sommes-nous ?"
          }

          p (className= "mb-8 mb-xs-4") {
            rich = true
            content = "Le projet <b>LaboDoc</b> est porté par des experts issus du domaine de la santé, qui partagent votre quotidien depuis plus de 20 ans.<br>" +
              "Autour d’eux, une <b>équipe Tech engagée</b> composée de développeurs, s’est mobilisée pour créer un outil <b>efficace</b>, <b>évolutif</b>, et entièrement pensé pour <b>vous faciliter la vie</b>."
          }
        }
      }

      div (className = "col-xl-3 col-lg-3 hidden-sm-and-down") {
        div(className = "page-width") {
          image(require("./img/page-whoarewe-header.png"))
        }
      }
    }

    div(className = "labodoc-background-white py-lg-14 py-xl-14") {
      id = "page-about-pros"

      div(className = "page-width mx-lg-14 mx-xl-16 hidden-xs hidden-sm") {
        h1 {
          content = "Nous partageons trois convictions simples"
        }

        p(rich = true) {
          content = """
            <b>La transparence</b>, pour garantir une information fiable, sourcée et plurielle<br>
            <br>
            <b>Le rôle de facilitateur</b>, pour que l’accès à ces ressources soit fluide et immédiat<br>
            <br>
            <b>L’envie d’offrir un service</b>, utile et gratuit, qui — on l’espère — contribuera à améliorer la prise en charge de vos patients
          """.trimIndent()
        }
      }
    }

    div(className = "labodoc-background-light-blue") {
      id = "page-about-features"

      div(className = "page-width") {
        div (className = "order-md-last d-flex justify-center align-center") {
          image(require("./img/page-whoarewe-info.png"))
        }
        div (className = "d-flex flex-column justify-center") {
          h1 {
            content = "Ce que nous offrons avec LaboDoc"
          }
          hr {}

          p {
            content = "Nous centralisons l'essentiel :"
          }

          ul {
            li {
              content = "Des informations officielles (HAS, ANSM, Base de données publique des médicaments…)"
            }

            li {
              content = "De nombreux liens utiles pour approfondir vos recherches : sociétés savantes, sites institutionnels ..."
            }

            li {
              content = "Des documents et communications proposés par les laboratoires"
            }
          }

          p(rich = true) {
            content = "Le tout organisé selon <b>votre spécialité</b> et les <b>centres d’intérêt</b> que vous avez choisis."
          }
        }
      }
    }

    div(className = "labodoc-background-white px-lg-12 px-xl-16") {
      id = "page-about-mission"

      div(className = "page-width mx-lg-12 mx-xl-16") {

        h1 {
          content = "Une idée simple, un outil pratique"
        }

        div (className = "d-flex flex-column justify-center align-center text-center") {
          p (className = "px-lg-10 px-xl-14") {
            rich = true
            content = "Sans prétention, juste une volonté : <b>vous faire gagner du temps</b>, tout en vous proposant uniquement des <b>informations de qualité</b>."
          }
        }

        navigoLink("", Page.Register()) {
          labodocButton("Je rejoins LaboDoc", className = "labodoc-background-middle-blue")
        }
      }
    }

    val swiper = require("swiper/element/bundle")

    swiper.register()
  }
}

fun Container.whoAreWePage(): WhoAreWePage {
  val whoAreWePage = WhoAreWePage()

  this.add(whoAreWePage)
  return whoAreWePage
}
